export class WishlistObjectQf {
  constructor() {
    this.LOCAL_STORAGE_CLIENT_NAME = window.Shopify.shop.replace(/.myshopify.com/g, '');
    this.LOCAL_STORAGE_WISHLIST_KEY = this.LOCAL_STORAGE_CLIENT_NAME + "-wishlist";
    this.BUTTON_ACTIVE_CLASS = "active-wishlist";
    this.GRID_LOADED_CLASS = "loaded";
    this.PRODUCT_CARD = "ct-product-card-inline";

    this.selectors = {
      button: "[button-shopping-list]",
      clearWishlist: ".clear-wishlist",
      grid: "[grid-wishlist]",
      gridContainer: ".wishlist-grid-container",
      sideCartGrid: "[side-cart-grid-wishlist]",
      productCard: ".product-card-inline",
      wishlistCount: "wishlistCount",
      emptyWishlist: ".empty-wishlist",
      cartContainer: "[cart-container]",
      savedCartTab: "[saved-cart-tab]"
    };

    this.init()
  }

  init() {
    this.wishlistCount();
    this.initButtons();
    this.attachSendWishlistEvent();
    this.addEventListeners();
    this.addWishlistOpenEventListener();
    this.setupCloseDrawerOnClickOutside();
    this.attachPrintShoppingListEvent();
    this.initGrid().then(() => {
      this.buttonCheck();
    })
  }

  buttonCheck() {
    const buttons = document.querySelectorAll(this.selectors.button);
    buttons.forEach((button) => {
      const productHandle = button.dataset.productHandle || false;
      if (this.wishlistContains(productHandle)) {
        button.classList.add(this.BUTTON_ACTIVE_CLASS);
      }
    });
  }

  initButtons = () => {
    document.body.addEventListener('click', (e) => {

      // Checks to see if the target that has been clicked contains wishlist data attribute
      const button = e.target.closest(this.selectors.button);
      if (button) {
        e.preventDefault();
        // Creates object from selected attributes
        const attributes = {};

        document.querySelectorAll(".product-form input").forEach(input => {
          if (input.checked) {
            attributes[input.name] = input.value;
          }
        });

        // Add the inner HTML of product-sub-total into attributes with the name of "Price"
        const productSubtotal = document.querySelector('[product-sub-total]');
        if (productSubtotal) {
          attributes["Price"] = productSubtotal.innerHTML;
        }

        let handle = button.dataset.productHandle || false;
        let title = button.dataset.productTitle || false;
        let model = button.dataset.productModel || false;
        let image = button.dataset.productImage || false;

        const product = {
          handle: handle,
          title: title,
          model: model,
          image: image,
          attributes,
        };

        console.log(button)

        // checks to see if the data attribute for product handle exists and outputs an error if not
        if (!product.handle) {
          return console.error(
            "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
          );
        } else {
          this.updateWishlist(product, e);
        }

        const cartDrawerContainer = document.getElementById('cart-drawer-container');
        if (cartDrawerContainer) {
          cartDrawerContainer.classList.add('open');
          document.body.classList.add('fixed');
        }

        // Grabs all wishlist buttons and adds active state
        const allButtonsForHandle = document.querySelectorAll(
          `${this.selectors.button}[data-product-handle="${product.handle}"]`
        );
        allButtonsForHandle.forEach((buttonAddClass) => {
          buttonAddClass.classList.toggle(this.BUTTON_ACTIVE_CLASS);
        });

        this.wishlistCount();
      }

      // Checks to see if the target that has been clicked contains clear wishlist class
      const clearButton = e.target.closest(this.selectors.clearWishlist);
      if (clearButton) {
        this.resetWishlist();
        this.initGrid()
      }
    });

    document.dispatchEvent(new CustomEvent("shopify-wishlist:init-buttons", {
      detail: { wishlist: this.getWishlist() },
    }));
  };

  addEventListeners() {
    window.addEventListener("desktop-cart-recommendations-rendered", () => {
      setTimeout(() => {
        this.buttonCheck();
      }, 500);
    });

    // Invoke the closeSideCartEvent method to setup the listener
    this.closeSideCartEvent();
  }

  closeSideCartEvent() {
    document.querySelectorAll('.closeSideCart').forEach(button => {
      button.addEventListener('click', () => {
        const cartDrawerContainer = document.getElementById('cart-drawer-container');
        if (cartDrawerContainer) {
          cartDrawerContainer.classList.remove('open');
          document.body.classList.remove('fixed');
        }
      });
    });
  }


  setupCloseDrawerOnClickOutside() {
    document.addEventListener('click', function (event) {
      const cartDrawer = document.getElementById('cart-drawer');
      const cartDrawerContainer = document.getElementById('cart-drawer-container');
      const isClickInsideDrawer = event.target.closest('#cart-drawer');
      const isClickInsideButton = event.target.closest(this.selectors.button);
      const isClickInsideWishlistOpener = event.target.closest('[data-open-wishlist]');

      // Check if the click is outside the cartDrawer and not on a wishlistOpener, a button or the closeSideCart
      if (
        cartDrawer &&
        !isClickInsideDrawer &&
        !cartDrawer.contains(event.target) &&
        !isClickInsideButton &&
        !isClickInsideWishlistOpener
      ) {
        cartDrawerContainer.classList.remove('open');
        document.body.classList.remove('fixed');
      }
    }.bind(this)); // bind this to the function so it can use the correct selectors
  }

  wishlistCount() {
    const wishlist = this.getWishlist();
    const wishlistCountElement = document.getElementById(this.selectors.wishlistCount);
    if (wishlistCountElement) {
      if (wishlist.length > 0) {
        wishlistCountElement.textContent = wishlist.length;
        wishlistCountElement.classList.remove("is-hidden");
      } else {
        wishlistCountElement.classList.add("is-hidden");
      }
    }
  }

  wishlistContains = (handle) => {
    const wishlist = this.getWishlist();
    return wishlist.some((item) => item.handle === handle);
  };

  getWishlist = () => {
    const wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist ? JSON.parse(wishlist) : [];
  };

  updateWishlist = (wishlistItem, e = null) => {
    const wishlist = this.getWishlist();
    const indexInWishlist = wishlist.findIndex((item) => item.handle === wishlistItem.handle);
    if (indexInWishlist === -1) {
      wishlist.push(wishlistItem);
    } else {
      wishlist.splice(indexInWishlist, 1);
    }

    this.setWishlist(wishlist, e);
  };

  setWishlist = (array, e) => {
    const wishlist = JSON.stringify(array);
    if (array.length) {
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
      document.dispatchEvent(
        new CustomEvent("shopify-wishlist:updated", {
          detail: { wishlist: array },
        })
      );
    } else {
      localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
      this.initGrid();
    }
    this.updateSideCartWishlist(e);
  };

  resetWishlist = () => {
    const allWishlistButtons = document.querySelectorAll(this.selectors.button);
    allWishlistButtons.forEach((button) => {
      button.classList.remove(this.BUTTON_ACTIVE_CLASS);
    });
    this.setWishlist([]);
  };

  async initGrid() {
    const grid = document.querySelector(this.selectors.grid);
    const gridContainer = document.querySelector(this.selectors.gridContainer);
    const urlParams = new URLSearchParams(window.location.search);
    const handlesParam = urlParams.get("handles");

    if (!grid || !gridContainer) {
      return;
    }

    const fallback = gridContainer.querySelector(this.selectors.emptyWishlist);

    if (handlesParam) {
      // If handles query parameter exists, decode the handles and load products
      const decodedHandles = this.decodeWishlistHandles(handlesParam);
      if (decodedHandles.length === 0) {
        grid.classList.add(this.GRID_LOADED_CLASS);
        if (fallback) {
          fallback.classList.add("show");
        }
        return;
      } else {
        if (fallback) {
          fallback.classList.remove("show");
        }
      }

      grid.classList.remove(this.GRID_LOADED_CLASS);

      await this.loadProducts(grid, decodedHandles);
    } else {
      // If no handles query parameter, load products from local storage
      const wishlist = this.getWishlist();
      if (wishlist.length === 0) {
        grid.classList.add(this.GRID_LOADED_CLASS);
        if (fallback) {
          fallback.classList.add("show");
        }
        return;
      } else {
        if (fallback) {
          fallback.classList.remove("show");
        }
      }

      grid.classList.remove(this.GRID_LOADED_CLASS);

      const handles = wishlist.map((item) => item.handle);
      await this.loadProducts(grid, handles);
    }
  }

  async loadProducts(grid, handles) {
    const products = await Promise.all(
      handles.map(async (productHandle) => {
        const productTileTemplateUrl =
          window.Shopify.routes.root +
          `products/${productHandle}?view=card&section_id=${this.PRODUCT_CARD}`;

        try {
          const response = await fetch(productTileTemplateUrl);
          if (!response.ok) {
            throw new Error("Error: " + response.status);
          }
          const data = await response.text();
          const htmlDocument = new DOMParser().parseFromString(data, "text/html");
          const productCard = htmlDocument.documentElement.querySelector(
            this.selectors.productCard
          );

          const wishlistButton = productCard.querySelector(".button-wishlist");
          if (wishlistButton) wishlistButton.classList.add(this.BUTTON_ACTIVE_CLASS);

          return productCard.outerHTML;
        } catch (error) {
          console.error(error);
          return null;
        }
      })
    );

    // Remove any null entries (failed fetches)
    const validProducts = products.filter((product) => product !== null);

    // Insert the products into the grid
    grid.innerHTML = validProducts.join("");

    grid.classList.add(this.GRID_LOADED_CLASS);
    document.dispatchEvent(
      new CustomEvent("shopify-wishlist:init-product-grid", {
        detail: { wishlist: handles },
      })
    );
  }

  attachPrintShoppingListEvent() {
    const wishlistItems = this.getWishlist();
    const wishlist = {
      items: wishlistItems
    };
    const sendWishlistButton = document.querySelector('.wishlist-submit-button');
    const errorTitle = sendWishlistButton.getAttribute('data-error-title');
    const errorMessage = sendWishlistButton.getAttribute('data-error-message');
    const printButton = document.querySelector('.print-shopping-list-button');
    if (printButton) {
      printButton.addEventListener('click', () => {
        console.log('Clicked Print: Wishlist Items... ', wishlist,)
        if (wishlistItems.length === 0) {
          let options = {
            title: errorTitle,
            message: errorMessage,
            delay: 3000,
          };

          window.toasty.addToast(options);
        } else {
          const sideCartGridContent = document.querySelector('.side-cart-saved-grid').innerHTML;
          const printWindow = window.open('', '_blank');
          printWindow.document.write(`
            <html>
              <head>
                <title>My Shopping List</title>
                <link rel="stylesheet" href="https://use.typekit.net/oyw2cuw.css">
                <style>
                  * {
                    box-sizing: border-box;
                    font-family: "proxima-nova";
                    font-size: 14px;
                    color: #1A1A1A;
                  }
                  html {
                    margin: 0; 
                  }
                  
                  body {
                    margin: 0;
                    background: #FFFFFF;
                  }
                  .product-card-inline {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    gap: 20px;
                    font-size: 14px;
                  }
                  .product-card-inline:not(:last-of-type) {
                    padding-bottom: 12px;
                    border-bottom: 2px solid #f6f6f6;
                    margin-bottom: 20px;
                  }
                  .product-card-inline .product-image {
                    // display: none;
                    width: 130px; 
                    min-width: 100px;
                    height: auto; 
                    aspect-ratio: 1; 
                  }
                  .product-card-inline .product-image img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                  }
                  .product-card-inline .product-info .product-title {
                    font-size: 18px;
                    font-weight: 900;
                    display: block;
                    margin-bottom: 9px;
                    line-height: 23px;
                    text-decoration: none; 
                    color: #000;
                  }
                  .product-card-inline .product-info .product-specs {
                    display: flex;
                    gap: 5px;
                    margin-bottom: 10px;
                  }
                  .product-card-inline .product-info .product-price {
                    display: flex;
                    gap: 5px;
                    margin-bottom: 10px;
                  }
                  .product-card-inline .product-info .product-remove-button {
                    display: none;
                  }
                  .product-card-inline .product-info .product-remove-button img {
                    width: 100%;
                    max-width: 20px;
                  }
                  .page-heading {
                    flex: 1;
                    font-size: 30px;
                    font-weight: 900; 
                    line-height: 1.4;
                    // color: #FFF;
                    // text-align: center;
                    margin: 0;
                  }
                    
                  .shopping-list-header {
                    width: 100%; 
                    // background: #cf122d;
                    padding: 0px 0px 20px; 
                  }
                  
                  .shopping-list-container {
                    display: flex; 
                    align-items: center;
                    justify-content: flex-start; 
                    flex-flow: row nowrap; 
                    gap: 30px 50px; 
                  }
                  
                  .page-width {
                    width: 100%; 
                    margin: 0 auto; 
                    padding: 0 3rem; 
                    max-width: 1000px;
                  }
                  
                  .site-logo {
                    width: 85px;
                    min-width: 85px;
                    height: 93px;
                    object-fit: contain; 
                    object-position: center top;
                  }
                  
                  .shopping-list-items {
                    display: flex; 
                    align-items: flex-start;
                    justify-content: flex-start;
                    flex-flow: column nowrap;
                    padding-top: 50px;
                    padding-bottom: 50px;
                  }
                </style>
              </head>
              <body>
                <div class="shopping-list-header">
                  <div class="shopping-list-container page-width">
                      <img src="https://cdn.shopify.com/s/files/1/0684/9059/2493/files/Cramer_Badge_Logo_RGB_SVG_9f11eeb0-afe1-4807-85a6-e2070feca275.svg?v=1738243129&width=300" alt="" width="300" height="300" loading="eager" fetchpriority="high" class="site-logo">
                    <h1 class="page-heading">My Shopping List</h1>
                  </div>
                </div>
                <div class="shopping-list-items page-width">
                  ${sideCartGridContent}
                </div>
              </body>
            </html>
          `);
          
          // Close the document to trigger loading
          printWindow.document.close();
          
          // Wait for the new window to load styles and fonts before printing
          printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          };
          
        }
      });
    }
  }

  initSideCartGrid() {
    const grid = document.querySelector(this.selectors.sideCartGrid);
    if (!grid) {
      return;
    }

    const wishlist = this.getWishlist();

    if (wishlist.length === 0) {
      grid.classList.add(this.GRID_LOADED_CLASS);
      document.getElementById('empty-wishlist-side-cart').classList.add('active');
      document.getElementsByClassName('grid-container')[0].classList.add('empty');
      document.querySelector('.side-cart-saved-grid').innerHTML = "";
      return;
    }

    grid.classList.remove(this.GRID_LOADED_CLASS);
    document.getElementById('empty-wishlist-side-cart').classList.remove('active');
    document.getElementsByClassName('grid-container')[0].classList.remove('empty');

    // Prepare promises for all wishlist items
    const fetchPromises = wishlist.map(wishlistItem => {
      const productTileTemplateUrl = window.Shopify.routes.root + `products/${wishlistItem.handle}?view=card&section_id=${this.PRODUCT_CARD}`;
      return fetch(productTileTemplateUrl)
        .then(response => {
          if (response.ok) {
            return response.text();
          } else {
            throw new Error("Error: " + response.status);
          }
        });
    });

    grid.innerHTML = "";

    // Use Promise.all to wait for all fetch operations to complete
    Promise.all(fetchPromises)
      .then(dataArray => {
        dataArray.forEach(data => {
          const htmlDocument = new DOMParser().parseFromString(data, "text/html");
          const productCard = htmlDocument.documentElement.querySelector(this.selectors.productCard);

          const wishlistButton = productCard.querySelector(".button-wishlist");
          if (wishlistButton) wishlistButton.classList.add(this.BUTTON_ACTIVE_CLASS);

          grid.insertAdjacentHTML("beforeend", productCard.outerHTML);
        });

        // Optional: add loaded class after all items have been processed
        grid.classList.add(this.GRID_LOADED_CLASS);
      })
      .catch(error => {
        console.error("Failed to fetch wishlist items:", error);
      });
  }

  updateSideCartWishlist(e) {
    const grid = e.target.closest(".side-cart-saved-grid.loaded");
    if (grid) {
      const productCard = e.target.closest(this.selectors.productCard);
      if (productCard) {
        productCard.remove();
        this.initSideCartGrid();
      }
    } else {
      this.initSideCartGrid();
    }
  }

  addWishlistOpenEventListener() {
    const wishlistOpeners = document.querySelectorAll('[data-open-wishlist]');
    wishlistOpeners.forEach(opener => {
      opener.addEventListener('click', () => {
        const cartDrawerContainer = document.getElementById('cart-drawer-container');
        if (cartDrawerContainer) {
          cartDrawerContainer.classList.add('open');
          document.body.classList.add('fixed');
        }
        this.initSideCartGrid();
      });
    });
  }

  // Method to encode the wishlist handles to base64 and return the encoded string
  encodeWishlistHandles(handles) {
    const handlesString = handles.join(',');
    const base64Encoded = btoa(handlesString);
    return base64Encoded
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }

  // Method to decode the base64 encoded wishlist handles and return them as an array
  decodeWishlistHandles(encodedString) {
    try {
      const base64Decoded = atob(
        encodedString
          .replace(/-/g, '+')
          .replace(/_/g, '/')
          .padEnd(encodedString.length + (4 - (encodedString.length % 4)) % 4, '=')
      );
      const handles = base64Decoded.split(',');
      return handles;
    } catch (error) {
      console.error('Error decoding wishlist handles:', error.message);
      return [];
    }
  }

  // Method to get the wishlist handles as a comma-separated string
  getWishlistHandlesString() {
    const wishlist = this.getWishlist();
    const handles = wishlist.map((item) => item.handle);
    return handles.join(',');
  }

  // Method to handle sharing wishlist via URL
  shareWishlistViaURL() {
    const wishlistHandles = this.getWishlistHandlesString();
    const encodedHandles = this.encodeWishlistHandles(wishlistHandles);
    const sharedURL = window.location.href.split('?')[0] + `?handles=${encodedHandles}`;

    // console.log('Shared URL:', sharedURL);
    // Do something with the sharedURL, like copying it to clipboard or displaying it for sharing.
  }

  // Method to handle sending the wishlist to Klaviyo
  sendWishlistToKlaviyo(wishlist) {
    // console.log('Wishlist:', wishlist);
    klaviyo.track('Wishlist Shared', wishlist);
  }

  // Attach this method to the SEND WISHLIST button's click event
  attachSendWishlistEvent() {
    const sendWishlistButton = document.querySelector('.wishlist-submit-button');
    const errorTitle = sendWishlistButton.getAttribute('data-error-title');
    const errorMessage = sendWishlistButton.getAttribute('data-error-message');
  
    if (sendWishlistButton) {
      sendWishlistButton.addEventListener('click', (event) => {

        const wishlistItems = this.getWishlist();
        const wishlist = {
          items: wishlistItems
        };
        
        console.log('wishlistItems:', wishlistItems);
        if (wishlistItems.length === 0) {
          event.preventDefault();
          let options = {
            title: errorTitle,
            message: errorMessage,
            delay: 3000,
          };
  
          window.toasty.addToast(options);
        } else {
          event.preventDefault();
          const emailInput = document.querySelector('div[saved-cart-tab] input[type="email"]');
          if (emailInput) {
            const emailAddress = emailInput.value;
            if (emailInput.validity.valid) {
              // console.log('Email Address:', emailAddress);
              klaviyo.identify({
                'email': emailAddress,
                'wishlist': wishlist.items,
                'wishlist_date': new Date().toISOString().slice(0, 19)
              }).then(() => {
                let options = {
                  title: 'Success',
                  message: 'Your wishlist has been emailed.',
                  delay: 3000,
                };
                window.toasty.addToast(options);
              }).catch((error) => {
                console.error('Error sending wishlist to Klaviyo:', error);
              });
              this.sendWishlistToKlaviyo(wishlist);
            }
          }
        }
      });
    }
  }

}

// window.WishlistObjectQf = WishlistObjectQf;
